import React from "react";
import styles from "./HomeHero.module.css";
import heroBg from "../assets/hero-crowd.jpg";

const HomeHero = () => {
  return (
    <section className={styles.hero}>
      <div
        className={styles.bg}
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden="true"
      />
      <div className={styles.overlay} />

      <div className={styles.inner}>
        <h1 className={styles.title}>あなたはどっち？</h1>

        <div className={styles.choiceGrid}>
<a className={`${styles.choiceCard} ${styles.choiceLeft}`} href="/events">
  <div className={styles.choiceIcon}>
    <img src="/icons/MusicalNote.svg" alt="Musical note" className={styles.choiceIconImage} />
  </div>
  <div className={styles.choiceText}>イベントに<br />行きたい</div>
</a>

<a className={`${styles.choiceCard} ${styles.choiceRight}`} href="/organizer">
  <div className={styles.choiceIcon}>
    <img src="/icons/Megaphone.svg" alt="Megaphone" className={styles.choiceIconImage} />
  </div>
  <div className={styles.choiceText}>イベントを<br />開催したい</div>
</a>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
